import { createDataset } from '@gonfalon/openapi/operations/createDataset';
import { deleteDataset } from '@gonfalon/openapi/operations/deleteDataset';
import { downloadDatasetFileRoute } from '@gonfalon/openapi/operations/downloadDatasetFileRoute';
import { getDataset } from '@gonfalon/openapi/operations/getDataset';
import { listDatasetErrors } from '@gonfalon/openapi/operations/listDatasetErrors';
import { listDatasets } from '@gonfalon/openapi/operations/listDatasets';
import { requestNewDatasetUploadUrl } from '@gonfalon/openapi/operations/requestNewDatasetUploadUrl';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { createQueryOptions } from '../internal/createQueryOptions';

export const listDatasetsQuery = createQueryOptions(listDatasets);
export const getDatasetQuery = createQueryOptions(getDataset);
export const getDatasetErrorsQuery = createQueryOptions(listDatasetErrors);

export const useCreateDataset = createMutationHook(createDataset, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: listDatasetsQuery.partialQueryKey() });
  },
});

export const useDatasetUploadUrl = createMutationHook(requestNewDatasetUploadUrl);

export const useDownloadDatasetFile = createMutationHook(downloadDatasetFileRoute);

export const useDeleteDataset = createMutationHook(deleteDataset);
